import { render, staticRenderFns } from "./serviceManage.vue?vue&type=template&id=73039174&scoped=true"
import script from "./serviceManage.vue?vue&type=script&lang=js"
export * from "./serviceManage.vue?vue&type=script&lang=js"
import style0 from "./serviceManage.vue?vue&type=style&index=0&id=73039174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73039174",
  null
  
)

export default component.exports